import { render } from "./SignUpWithOtp.vue?vue&type=template&id=75c429e8&ts=true"
import script from "./SignUpWithOtp.vue?vue&type=script&lang=ts"
export * from "./SignUpWithOtp.vue?vue&type=script&lang=ts"

import "./SignUpWithOtp.vue?vue&type=style&index=0&id=75c429e8&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__